/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/FrameAccumulationTypes.yaml
import { PartiallyConstructible } from '../utils/utils';
export const ConfirmationMethodValues = ['EXACT', 'INTERPOLATE'];
/**
Configuration for how to accumulate results.
*/
export class ResultAccumulationConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<ResultAccumulationConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Method used to confirm a result.
          
          Default is EXACT
          */
        this.confirmationMethod = 'EXACT';
        /**
          Number of confirmations required to consider a result confirmed (see ConfirmationMethod).
          Requiring more confirmations will increase the reliability of the result but also the time to
          gather enough confirmations.
          
          Default is 3
          */
        this.minConfirmations = 3;
        /**
          Minimum confidence required to consider a field confirmed.
          
          Default is 0.8
          */
        this.minConfidenceForStableField = 0.8;
        /**
          Will auto-clear the cache if this number of frames have been a different document type or empty.
          
          Default is 4
          */
        this.autoClearThreshold = 4;
        if (source.confirmationMethod !== undefined) {
            this.confirmationMethod = source.confirmationMethod;
        }
        if (source.minConfirmations !== undefined) {
            this.minConfirmations = source.minConfirmations;
        }
        if (source.minConfidenceForStableField !== undefined) {
            this.minConfidenceForStableField = source.minConfidenceForStableField;
        }
        if (source.autoClearThreshold !== undefined) {
            this.autoClearThreshold = source.autoClearThreshold;
        }
    }
}
/**
Configure the frame accumulation process.
*/
export class AccumulatedResultsVerifierConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<AccumulatedResultsVerifierConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Maximum number of accumulated frames to inspect to verify a scan result.
          
          Default is 3
          */
        this.maximumNumberOfAccumulatedFrames = 3;
        /**
          Minimum number of accumulated frames that have an equal result in order for the result to be considered verified.
          
          Default is 2
          */
        this.minimumNumberOfRequiredFramesWithEqualScanningResult = 2;
        if (source.maximumNumberOfAccumulatedFrames !== undefined) {
            this.maximumNumberOfAccumulatedFrames = source.maximumNumberOfAccumulatedFrames;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualScanningResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualScanningResult =
                source.minimumNumberOfRequiredFramesWithEqualScanningResult;
        }
    }
}
//# sourceMappingURL=FrameAccumulationTypes.js.map